<template>
  <div class="md-layout-item md-size-100 align-button">
    <md-button :disabled="!hasBackStep" class="md-primary md-raised button" @click="navigateFunc(-1)">
      <md-icon>keyboard_arrow_left</md-icon>
      <span> {{ $t("common.goBack") }}</span>
    </md-button>
    
    <md-button :disabled="!hasNextStep" class="md-primary md-raised button" @click="navigateFunc(1)">
      <span> {{ $t("common.next") }}</span>
      <md-icon>keyboard_arrow_right</md-icon>
    </md-button>
  </div>
</template>

<style>
.align-button {
  display: flex;
  justify-content: space-between;
  padding: 10px;
}
</style>

<script>
export default {
  name: "BottomNavButtons",
  props: {
    navigateFunc: {
      type: Function,
      required: true,
    },
    hasNextStep: {
      type: Boolean,
      default: true,
    },
    hasBackStep: {
      type: Boolean,
      default: true,
    }
  },
};
</script>
